import { render, staticRenderFns } from "./SignUpInfo.vue?vue&type=template&id=27f6867d&scoped=true"
import script from "./SignUpInfo.vue?vue&type=script&lang=js"
export * from "./SignUpInfo.vue?vue&type=script&lang=js"
import style0 from "./SignUpInfo.vue?vue&type=style&index=0&id=27f6867d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f6867d",
  null
  
)

export default component.exports